export default {
  vote: {
    team: {
      about_title: 'Kanuni',
      about_con:
        '<p>1. Washiriki wa timu wanaweza kualika marafiki 2 kutengeneza timu ili kushiriki kwenye duru ya bahati.</p>\
      <p>2. Zawadi hiyo ni Siku 1 ya VIP, VIP ya siku 7, VIP ya Siku 30, Simu, Runinga, Decoder, kadi ya Recharge.</p>\
      <p>3. Devices na akaunti mpya tu ambazo zimetambuliwa kama watumiaji ndio zinaweza kujiunga kwenye timu.</p>\
      <p>4. Kila mtumiaji ana jumla ya fursa 10 za duru ya bahati.</p>\
      <p>5. Shughuli ni halali mpaka tarehe 25, Dec, 2019</p>\
      <p>6. StarTimes ON ina haki zote kwa maelezo ya mwisho.</p>',
      my_prizes: 'Zawadi Zangu',
      my_won: 'GOT: Siku {0} za VIP',
      share_btn: 'Shiriki Bahati Yako',
      invite_tips: 'Alika 2 Marafiki Mpya Kujiunga na Kupata Zawadi',
      invite_btn: 'Waambie marafiki wajiunge',
      invite_btn2: 'Jisajili na uwaambie marafiki',
      share10_1: 'Tunajivunia sana wewe!',
      share10_2: 'Uliunda timu 1 -10!',
      invite_con: 'Jiunge kwenye timu yangu na utapata VIP na kuangalia bila malipo.',
      invite_ima: '{0} kakualika kwenye timu ili ushinde VIP na zawadi.',
      ima_saved: 'Imehifadhiwa kwenye folda ya karibu',
      copied: 'kunakiliwa',
      copy_text: 'COPY',
      search_team: 'Tafuta timu',
      search: 'SEHEMU',
      search_nores: 'Oops, hakuna majibu yaliyopatikana.',
      join: 'JIUNGE KWENYE TIMU',
      join_s: 'JOIN',
      reserves: 'VIP itaanza kutumika mara moja kwenye ME.',
      form_late: 'Oops, umechelewa kidogo, unda timu mpya.',
      form_newbtn: 'UNDA TIMU MPYA',
      form_succ: 'Hongera! Umefanikiwa kushirikiana na umepata nafasi 1 ya kupata VIP na zawadi!',
      form_noform: 'Samahani, bado hujaunda timu. Shirikisha rafiki zako kujiunga!',
      boardcast_con: '{0} ameshinda {1}!',
      invite_tip: '{0} <br/>anakualika kujiunga kwenye timu na upate zawadi!',
      full_team: 'Samahani, timu ina washiriki wa kutosha.',
      follow_team: 'Timu zifuatazo bado zina nafasi moja, jiunge sasa!',
      invite_won: 'Watu {0} tayari wanayo VIP.',
      team_id: 'Kitambulisho cha Timu',
      invite_infotit: 'Angalia TV mubashara na furahia maudhui bora ya VOD',
      joinpop_newuser: 'Inakusubiri wewe tu, bonyeza kujiunga.',
      change: 'Badilisha',
      joinpop_olduser:
        'Oh, rafiki yangu wa zamani. Mtumiaji mpya tu ndiye anayeweza kujiunga. Pia unaweza kualika marafiki na kuunda timu mpya kupata zawadi.',
      download_tip: 'Anza kupakua apk sasa? (12M)',
      show_lucky: 'WAONYESHE JINSI NILIVYO NA BAHATI',
      download_join: 'Pakua ili kujiunga sasa',
      have_team: 'Unaweza kumiliki timu moja kwa wakati mmoja.',
      input_error: 'Tafadhali ingiza Kitambulisho halali cha Timu.',
      network_error: 'Tatizo la mtandao.',
      tips: `Tips: <br/>Zawadi ya VIP uliyopata itafanya kazi kutoka leo.`,
      no_awards: 'Bado hakuna zawadi.',
      draw_title: 'Chora zawadi yako',
      draw_button: 'DURU',
      draw_none: 'Asante, itakuwa bora wakati mwingine.',
      my_won_one: 'GOT: Siku {0} za VIP',
      facebook: 'Facebook',
      whatsapp: 'Whatsapp',
      xender: 'Xender',
      download: 'Hifadhi picha',
      copy: 'Nakili link',
      download_apk: 'Download Now',

      //add
      shareTitle: 'Make A Team to Win Free VIPS',
      shareText: 'Join my team and send you VIP to watch it all for free',
      countdownTitle: 'Remaining',
      enterID: 'ingiza kitambulisho cha timu',
      welcome: 'Karibu',
      newuser_popup: 'ikiwa ulialikwa na marafiki',
      or: 'au',

      //no need
      prize_step: 'Fuata hatua hapa chini kupata zawadi sasa.'
    },
    euro: {
      rules: 'Prizes',
      rule_title: `<p style="color:#F3953A;font-weight:bold">Rules and Prizes</p>`,
      rule_text: `<p>1.Activity time:</p>
      <p>The activity is from June 7th to July 13th, and we will do two predictions:</p>
      <p>a.June 7th to June 19th, predicting where each team in each of the six groups will finish and the four best third-placed teams who will go to the knockout stage;</p>
      <p>b.June 24th to July 6th, predicting which team win into the next round and which teamwill get the crown in the final.</p>
      <p>2.Activity prizes:</p>
      <p>Prediction Award:</p>
      <p>1-year free Max package.</p>
      <p>Lucky Award:</p>
      <p>1-month free Max package</p>
      <p>1-week free Max package</p>
      <p>3-days free Max package</p>
      <p>1-day free Max package</p>
      <p>3.Activity Rules:</p>
      <p>a.All need to register and log in before participating the prediction activity;</p>
      <p>b.Only if you link your DVB card with OTT account, then you can have a chance to win Prediction Award.</p>
      <p>c.Participate to get points. In the group stage, you will get 2 points every time you correctly predict the position of one team, and you will get 1 point for each team in the best 4 third-placed teams, a total of 52 points. In the knockout stage, you need to predict before the game starts, otherwise you won’t get points of this game. You willget 3 points for each team in round of 16 and quarter-finals, and you will get 4 points for each team in semi-finals and final match, a total of 48 points. If you participate in these two predictions, you have chance to get 100 points. Finally, you will get lucky awards according to your points.</p>
      <p>4.Activity awards:</p>
      <p>a.Prediction Award: </p>
      <p>Winners of prediction award will be randomly selected from people who predict the most accurately on the June 25th and July 13th. The results will be displayed on the Facebook and prediction page.</p>
      <p>b.Lucky Award: </p>
      <p>Points: >=90, 1 months Max package</p>
      <p>Points: <90 and >=70, 1 week Max package</p>
      <p>Points: <70 and >=50, 3 days Max package</p>
      <p>Points: <50 and > =30, 1 day Max package</p>
      <p>During the event, if you log in for more than 10 days, you will surely win a lucky award.</p>
      <p>These prizes will be released to the winners’ account in the 3 to 5 working days after the end of event.</p>
      <p>5.Additional information</p>
      <p>a.You need to provide an exact phone number and keep it unblocked. The phone number is an important certificate for awarding;</p>
      <p>b.Malicious registration is prohibited. If any malicious registration is found, the organizer has the right to cancel the qualification of the event and reserve the right to pursue their legal responsibility;</p>
      <p>c.The deadline for redemption is July 20th, if we fail to get in touch with you before the deadline, it will be considered invalid.</p>
      <p>d.The organizer reserves the right to change these terms and reserves the right to final interpretation.</p>`,
      rule_text_ug: `<p>1.Activity time:</p>
      <p>The activity is from June 7th to July 13th, and we will do two predictions:
      a.June 7th to June 19th, predicting where each team in each of the six groups will finish and the four best third-placed teams who will go to the knockout stage;</p>
      <p>b.June 24th to July 6th, predicting which team win into the next round and which teamwill get the crown in the final.</p>
      <p>Besides these two predictions, there will be four lotteries for all users who participate in the prediction activity and meet the conditions, on the June 18th, June 25th, July 1st, July 11th.</p>
      <p>2.Activity prizes:</p>
      <p>Prediction Award:</p>
      <p>First Prize:   10M UGX (Individual prize）</p>
      <p>Second Prize:   Senke Motorcycle (3 highest score)</p>
      <p>Third Prize:   StarTimes 32 inch TV</p>
      <p>Fourth Prize:   Euro 2020 Football</p>
      <p>Lottery Award:</p>
      <p>First Prize:   Senke Motorcycle (2 lucky customers)</p>
      <p>Second Prize:   StarTimes 32 inch TV</p>
      <p>Third Prize:   Euro 2020 Football</p>
      <p>Fourth Prize:   Euro 2020 Jersey</p>
      <p>Lucky Award:</p>
      <p>  1-month free Max package</p>
      <p>  1-week free Max package</p>
      <p>  3-days free Max package</p>
      <p>  1-day free Max package</p>
      <p>3.Activity Rules:</p>
      <p>a.All need to register and log in before participating the prediction activity;</p>
      <p>b.Only if you link your DVB card with OTT account, meet at least one of the following conditions during this event period from June 1st to July 11th and before the draw, then you can have a chance to win physical prizes: Prediction Award and Lottery Award.</p>
      <p>i.Subscribe UGX 20,000/- on Antenna Decoder for Basic Bouquet Customers, If onNOVA Antenna, Upgrade your bouquet to Basic then Subscribe the UGX 20,000/-;</p>
      <p>ii.Subscribe Classic monthly Bouquet at least once on Antenna decoder;</p>
      <p>iii.Subscribe Smart monthly Bouquet at least once on Antenna decoder;</p>
      <p>iv.Subscribe Super monthly Bouquet at least once on Antenna decoder;</p>
      <p>v.Buy a new decoder and activate.</p>
      <p>c.Participate to get points. In the group stage, you will get 2 points every time you correctly predict the position of one team, and you will get 1 point for each team in the best 4 third-placed teams, a total of 52 points. In the knockout stage, you need to predict before the game starts, otherwise you won’t get points of this game. You willget 3 points for each team in round of 16 and quarter-finals, and you will get 4 points for each team in semi-finals and final match, a total of 48 points. If you participate in these two predictions, you have chance to get 100 points. Finally, you will get lucky awards according to your points.</p>
      <p>4.Activity awards:</p>
      <p>a.Prediction Award: </p>
      <p>Winners of prediction award will be randomly selected from people who predict the most accurately on the June 25th and July 13th. The results will be displayed on the Facebook and StarTimes ON prediction page and Sanyuka TV.</p>
      <p>b.Lottery Award: </p>
      <p>Winners are randomly selected from all those who meet the conditions for participation on the June 18th, June 25th, July 1st, July 11th.</p>
      <p>During the event, if you log in for more than 10 days, you will surely win lucky award. The results will be displayed on the Facebook, StarTimes ON page and Sanyuka TV.</p>
      <p>c.Lucky Award: </p>
      <p>Points: >=90, 1 months Max package</p>
      <p>Points: <90 and >=70, 1 week Max package</p>
      <p>Points: <70 and >=50, 3 days Max package</p>
      <p>Points: <50 and >=30, 1 day Max package</p>
      <p>During the event, if you log in for more than 10 days, you will surely win lucky award.</p>
      <p>For prediction award and lottery award, those physical award, winners need to contact the organizer. After the necessary verification, awards will be awarded.</p>
      <p>For Lucky award, it will be released to the winners’ account in the 3 to 5 working days after the end of event.</p>
      <p>5.Additional information</p>
      <p>a.You need to provide an exact phone number and keep it unblocked. The phone number is an important certificate for awarding;</p>
      <p>b.Malicious registration is prohibited. If any malicious registration is found, the organizer has the right to cancel the qualification of the event and reserve the right to pursue their legal responsibility;</p>
      <p>c.The deadline for redemption is July 20th, if we fail to get in touch with you before the deadline, it will be considered invalid.</p>
      <p>d.The organizer reserves the right to change these terms and conditions and the right to final interpretation.</p>`,
      rule_text_gh: `<p>Submit your prediction for the final ranking of each group, and the four best third-place teams <strong>by June 19</strong></p>
      <p>AND</p>
      <p>Your prediction for the winner of each knockout stage game, all the way to the Final, <strong>by the beginning of each game</strong></p>
      <p>for a chance to win these AMAZING prizes!</p>
      <p><strong><u>The Prize</u></strong></p>
      <p>You will get points for every correct prediction. If you are among the BEST predictors, you will be entered into a draw for one of the three following prizes!</p>
      <p>Techno Phantom 10</p>
      <p>Techno Camon 17</p>
      <p>Techno Spark 7</p>
      <p>Winners are announced on StarTimes Facebook and Instagram page! Subscribe to them today to stay updated!</p>
      <p><strong><u>Remember!</u></strong></p>
      <p>Only active users of StarTimes decoders or VIP users of the APP are eligible to participate. Youneed to provide this information and a phone number when submitting your prediction and for receiving the prize.</p>
      <p>The deadline to redeem your prize is July 20. If we cannot get in touch with you then，your prize will be invalidated.</p>
      <p>*StarTimes reserves the right to change these terms and conditions at any time without prior notice.</p>`,
      share: 'Share',
      share_title: 'EURO2020 Prediction',
      share_text: 'I am watching Euro2020 on StartimesON, and I can win prizes by guessing the result of the match. Come and join me now!',
      confirm: 'Confirm',
      cancel: 'Cancel',
      group: 'Group',
      third_teams_title: 'Predict the four best third-placed teams',
      confirm_submit_info: 'Are you sure about your predictions？',
      prize_title: 'LIST OF PRIZES',
      result_tips_success: 'You have successfully submitted your predictions!',
      result_tips_end: 'This prediction has ended, please participate in the next one.',
      sign_in: 'Sign in',
      sign_in_info: 'Sign in to start your prediction!',
      vip_tips:
        'Please ensure that you have purchased a membership package or linked your DVB decoder, which is a prerequisite for obtaining prizes:',
      dvb_link_decode: 'LINK DECODER',
      ott_get_vip: 'GET VIP',
      phone_tips: 'In order to inform you when you win the prize, please fill in the correct contact information:',
      phone_error_info: 'Please enter a valid phone number!',
      phone_placeholder: 'Please enter your phone number',
      phone_confirm_info:
        'The phone number is your only proof of receiving the prize. Please check it carefully and you cannot modify it after submission.',
      network_error: 'Poor network, please check your network!',
      change_rank_tip: 'Click the up and down arrows to rank the teams',
      no_finish_tip: 'You need to choose the 4 best third-placed teams to complete your prediction!',

      // 二期补充
      next: 'NEXT',
      back: 'BACK',
      no_finish_tip2: 'Please complete all predictions before proceeding to the next round',
      no_participate: 'You did not participate in the last event.',
      no_prize: "Unfortunately, you didn't win the prize last time!",
      get_prize: 'Congratulations to you for getting ',
      get_point1: 'You have earned ',
      get_point2: ' points, predict to get more!',
      submit_success: 'You have successfully submitted your predictions! Stay tuned for the lucky draw results!',
      swipe_tip: 'Swipe to see all',
      loading: 'Loading...'
    },
    africa: {
      rule: 'KANUNI',
      share: 'SAMBAZA',
      rule_title: `<p style="color:#CB043F;font-weight:bold;">KANUNI</p>`,
      rule_text: `<p>1. Bashiri mchezo siku hiyo. Haiwezekani kutabiri baada ya kuanza kwa mchezo.</p><p>2. Baada ya kila utabiri, kuna nafasi ya kushiriki katika bahati nasibu.</p><p>3. Ukikisia alama zote, unapata pointi 5.</p><p>Ikiwa ulikisia alama za mchezo mmoja kwa usahihi na uhusiano wa kushinda-hasara kati ya hizo mbili ni sahihi, utapata pointi 3.</p><p>Ikiwa ulikisia tu alama za mchezo mmoja kwa usahihi, utapata pointi 2.</p><p>Ikiwa unadhani tu uhusiano wa kushinda-hasara (pamoja na kufungana), unapata pointi 1.</p><p>Maelekezo:</p><p>Watumiaji walioingia pekee ndio wanaostahiki kushiriki katika ubashiri na bahati nasibu, na pia kushiriki katika kupanga alama.</p>`,
      prize_details: 'MAELEZO YA TUZO',
      prize_details_text1: 'Watumiaji walio na alama za juu zaidi watazawadiwa pikipiki',
      prize_details_text2: 'Watumiaji walio na ya pili na ya tatu watatuzwa MAXVIP maisha yao yote',
      prize_details_text3: 'Watumiaji walio na nambari ya nne na ya tano watatuzwa uanachama wa miaka mitatu',
      prize_details_text4: 'Watumiaji watakao pata nafasi ya sita hadi ya kumi watazawadiwa VIP ya mwaka mmoja',
      fixture: 'RATIBA',
      africa_rank: 'POINTI CHEO',
      points: 'Pointi: ',
      replay: 'CHEZA TENA',
      predict: 'TABIRI',
      predicted: 'ILIYOTABIRIWA',
      live: 'MUBASHARA',
      over: 'MWISHO',
      my_points: 'Pointi Zangu: ',
      my_ranking: 'Nafasi Yangu: ',
      lottery_title: 'ENEO LA BAHATI NASIBU',
      lottery_des:
        'Kila wakati utabiri unafanywa, nafasi moja ya kuchora bahati nasibu itatolewa, na watumiaji wa avkodare ya VIP au LINK watapata nafasi moja zaidi.',
      lottery_left: 'Idadi iliyosalia ya michoro: ',
      my_prize: 'ZAWADI YANGU',
      start: 'MWANZO',
      has_got: 'amepata',
      more_vote_title: 'JINSI YA KUPATA MICHORO ZAIDI',
      predict_btn: 'TABIRI',
      predict_des: '1. Fanya utabiri',
      ott_btn: 'NUNUA VIP',
      ott_des: '2. Faida za StarTimesON VIP',
      dvb_btn: 'UNGANISHA',
      dvb_des: '3. StarTimes DVB faida',
      buy_btn: 'NUNUA',
      buy_des: '4. Nunua kiasi chochote cha VIP au lipia mara moja',
      share_btn: 'SAMBAZA',
      share_des: '5. Shiriki na watumiaji wapya kwa kushiriki katika shughuli',
      lottery: 'Bahati nasibu',
      video_title: 'VIVUTIO',
      confirm: 'THIBITISHA',
      lottery_no_left:
        'Kwa kila ubashiri huja nafasi ya michoro ya bahati zaidi! Kununua VIP na LINK avkodare yako kuongeza nafasi yako ya kushinda!',
      predict_success:
        'wasilisha ubashiri wako ili upate nafasi ya kushinda kwa wingi! Nunua VIP, unganisha dekoda yako au ushiriki ili kuongeza nafasi yako ya kushinda!',
      lottery_success: 'Hongera kwa kushinda ',
      lottery_sorry: 'Asante kwa kushiriki!',
      lottery_again: 'Hongera kwa kupata nafasi ya kushinda!',
      no_left: ' Bahati nasibu yako imetumika kabisa!',
      to_signin: 'Shiriki katika tukio baada ya kuingia! Shiriki katika hafla ili kushinda zawadi kubwa!',
      lottery_btn: 'DURU',
      add_btn: 'Ongeza nafasi',
      sign_btn: 'INGIA',
      continue_btn: 'ENDELEA',
      // 补充
      before_start: 'Shughuli haijaanza!',
      after_end: 'Shughuli imeisha!',
      ok: 'SAWA',
      loading: 'Inapakia…',
      download: 'PAKUA'
    },
    appvote: {
      select_one: 'Chagua moja',
      select_more: 'Chagua moja au zaidi',
      pre_vote: 'Upigaji Kura Baada ya Uchaguzi',
      vote: 'Piga kura Sasa',
      download_btn: 'Download sasa',
      vote_success: 'Upigaji kura ulifanikiwa! Pakua Startimes ON kuona matokeo na video nyingine nzuri zaidi zijazo!'
    },
    bssregister: {
      rule_btn: 'SHERIA',
      rule: '<p style="color:#55A081;font-weight:bold;">SHERIA</p>',
      rule_text: `\nOnline Audition\n\n1. Muda wa usaili wa mtandaoni: 9 Nov,2024- 22 Dec,2024\n\n2. Masharti\n\nI.Jirekodi ukiimba wimbo mzima\n\nII.Jirekodi mara moja, usihariri wala kurekebisha chochote.\n\nIII.Wimbo unatakiwa ubebe tabia zote za sauti ambazo zinaonyesha hisia za mwimbaji\n\nIV.Mshiriki anatakiwa kujirekodi sura yake ikionekana. Uimbaji wa kughushi hauruhusiwi.\n\n3. Njia ya kujiandikisha\n\nI.Kujisajili kwa njia ya mtandao- StarTimes ON APP\n\nWashiriki wajirekodi wakiimba wimbo mzima, kisha wapandishe video zao katika mtandao wa YouTube (Nakili link); Kisha pakua na ufungue STARTIMES ON APP, ingia sehemu ya usaili wa BSS; jaza taarifa zako muhimu, weka link yako ya Youtube ukiimba; wasilisha, kisha subiri kazi yako hiakikiwe.\n\nII.Njia nyingine ya kujiandikisha-Instagram\n\nJirekodi video ukiimba kisha ipost katika mtandao wa Instagram, na weka hashtag #bssonlineaudition2024 na mwisho tag @startimestz\n\n*MUHIMU:Kazi zote za washiriki wa kimtandao zitahakikiwa kwa masaa 48 baada ya ku-upload, na matokeo yatawekwa kwenye chaguzi zitakazofuata.\n\n4. Sheria za uteuzi wa mtandao\n\nBaada ya machapisho, upigaji kura utafunguliwa rasmi kwenye StarTimes ON APP “Online Audition Election Voting Channel”. Mpaka mwisho, washindi 1~5 watafuzu kuingia kwenye hatua ya mtoano wa mashindano.\n\nUsaili usio wa kimtandao\n\n1. Muda na mahali\n\n*Tarehe za usaili wa BSS*\n\n• Nov 09 - 10 : Arusha 🇹🇿\n\n• Nov 16 - 17 : Mwanza 🇹🇿\n\n• Nov 23 - 24 : Kampala 🇺🇬\n\n• Nov 29 - 30 : Nairobi 🇰🇪\n\n• Dec 07 - 08 : Babati 🇹🇿\n\n2.Njia ya usaili\n\nWashiriki watakao shiriki kwenye usaili usio wa kimtandao wanashauriwa kwenda kwenye maeneo yaliyotajwa hapo juu kutokana na muda wa usaili.\n\nKuna nafasi 5 za usaili usio wa kimtandao katika kila usaili (isipokuwa Dar es salaam),majaji 4 waliobobea watasaili washiriki kwa NDIO au HAPANA. Washiriki watakaopita kwenye usaili siku hiyo watashiriki tena kwenye usaili wa pili kwa siku inayofuata kwaajili ya kuchagua watakao songa mbele kwenye mashindano.\n\n4. Mengineyo\n\nKwa sababu ya uwepo wa watu wengi wanaotokea wakati wa usaili, uandaaji wa kipindi pia hufanyika siku hiyo ya usaili. Unashauriwa kuwahi mapema eneo la usaili na ufuate maelekezo.`,
      loading: 'Loading...',
      name: 'JINA',
      sex: 'JINSIA',
      male: 'Kiume',
      female: 'Kike',
      select_placeholder: 'Tafadhali chagua',
      birthday: 'TAREHE YA KUZALIWA',
      year: 'Mwaka',
      month: 'Mwezi',
      day: 'Siku',
      number: 'NAMBARI YA SIMU',
      number_error: 'Tafadhali ingiza namba ya simu sahihi',
      country: 'COUNTRY',
      city: 'MAKAZI YA SASA',
      profession: 'KAZI',
      link: 'LINK YA VIDEO',
      link_placeholder: 'Links za video za Tik Tok au Instagram au YouTube',
      howto_getlink: 'JINSI YA KUPATA LINK YA VIDEO?',
      end_text: 'SAMAHANI, USAJILI UMEKWISHA',
      offway_title: 'OFF-LINE REGISTRATION',
      offway_text: `Usaili wa Bongo Star Search msimu wa 15 utafanyika Arusha, Mwanza, Kampala Uganda, Nairobi Kenya, Babati na Dar es Salaam.<br/>Kivumbi kitaanzia Arusha siku ya tarehe 09/11/2024. Changamkia fursa hii adhim. Kuhusu namna ya kujiunga na mashindano,tafadhali bonyeza link. Usisahau nafasi nyingine zaidi zinakusubiri wewe!`,
      success_title: 'USAJILI UMEFANIKIWA',
      success_text:
        'Tutaikagua kazi yako kama imeidhinishwa, kazi yako itaonyeshwa kwenye Startimes ON  APP ndani ya masaa 48. Usisahau kujipigia kampeni mwenyewe!',
      ok: 'SAWA',
      share: 'SHIRIKI',
      share_title: 'Wewe ndiye nyota wa Bongo unayefuata',
      share_text: 'Rekodi video yako ukiimba,jisajili SASA!Nafasi hii ni yako.',
      ke: 'Kenya',
      ug: 'Uganda',
      tz: 'Tanzania',
      profession_list: [
        'Mauzo / Masoko',
        'Uhasibu / Utawala',
        'Mradi / Ubora',
        'IT / Mtandao / Telcom',
        'Mali isiyohamishika / ujenzi',
        'Fedha',
        'Ununuzi / Usafirishaji',
        'Uzalishaji / Utengenezaji',
        'Vyombo vya habari / Sanaa / Ubunifu',
        'Mshauri / kisheria / elimu',
        'Sekta ya Huduma',
        'Nishati / Mazingira',
        'Kilimo',
        'Utafiti wa kisayansi',
        'Kazi ya muda / Mafunzo ya kazi / Nyingine'
      ],
      title1: 'MCHAKATO WA KUJIUNGA MTANDAONI',
      title2: 'NJIA NYINGINE ZA USAILI',
      title3: 'MAONYESHO YA ZAMANI',
      submit: 'WASILISHA'
    },
    bssvote: {
      rule_btn: 'SHERIA',
      rule: '<p style="color:#55A081;font-weight:bold;">Sheria za kupiga kura</p>',
      rule_text: `\nKutoka tarehe 9 Nov hadi 22 Dec, una kura 5 kila siku baada ya kuingia. Kura zitakuwa zinajumlishwa na kuwa halali hadi mwisho wa shughuli.\n\nUnaweza kumpigia kura mshiriki yeyote unayempenda!\n\nWapatie link marafiki zako na waombe wapakue App ya StarTimes ON ili kupata kura zaidi! Utapata kura 5 zaidi kwa kila mtumiaji mpya. Unavyozidi kuleta watumiaji wapya, ndivyo unavyopata kura zaidi! Na pia ukiunganisha Dikoda yako na App, au ukiwa VIP wa App, utapata kura 20 zaidi!\n\nKila wakati unapopiga kura, utapata nafasi moja ya kupata StarTimes Dikoda, Dish, au Max VIP ya Mwezi ya StarTimes ON na Kuponi.\n\nZawadi zitakuwa zinatolewa siku ya pili ya kazi katika Me-> Kuponi zangu.\n\nWagombea 10 wa juu walio na kura nyingi wataweza kuingia kwenye mahojiano ya mwisho, na mwishowe wagombea 5-10 watachaguliwa na mwalimu kushiriki katika 2024BSS S15.`,
      new_info: 'Shiriki katika upigaji kura upate kura nyingi.',
      way_link: 'KUPUTA KURA ZAIDI?',
      vote_left: 'KURA ZILIZOBAKI:',
      vote: 'VOTE',
      more_singer: 'ANGALIA WASHIRIKI WOTE',
      tosign: 'JISAJILI',
      tofinish: 'KAMILISHA',
      finished: 'IMEKAMILIKA',
      invite: 'ALIKA',
      invite_text: 'FANIKIWA KUALIKA RAFIKI:',
      info: `Kila wakati unapopiga kura,<br />utapata nafasi ya kushinda zawadi.`,
      lottery_left: 'NAFASI ZILIZOBAKI:',
      tip: 'TAFUTA ZAWADI KWENYE ME -> KUPONI YANGU',
      vote_title: 'CHAGUA KURA ZAKO',
      close: 'GHAIRI',
      share_title: 'Wewe ndiye nyota wa Bongo unayefuata',
      share_text:
        'Chaguo ni lako! Chagua mgombea unayempenda na umsaidie kushiriki kwenye hatua ya utafutaji wa washiriki wa Bongo Star Search 2024.',
      ok: 'SAWA',
      share: 'SHIRIKI',
      cancel: 'FUTA',
      before_start: 'Upigaji kura utaanza tarehe 9th Novemba, kwa hiyo kaa tayari!',
      after_end: 'Samahani, kura zimekwisha.',
      voteleft0: 'Samahani, kura yako iliyobaki ni 0.',
      get_more: 'KUPUTA KURA ZAIDI?',
      nomore: 'Kura imeshindikana. Hakuna kura za kutosha zilizobaki.',
      fail1: 'Upigaji umefanikiwa! Shirikisha marafiki kupata kura zaidi.',
      fail2: 'Upigaji umefanikiwa! Umepata nafasi ya kupata zawadi kwa kupitia mchezo wa ukurasa huu.',
      sign_tip: 'Tafadhali jisajili ili uanze mchuano wa bahati.',
      nomore_vote: 'Nenda kupiga kura ili kushinda bahati nzuri ya kuteka. Kila wakati unapopiga kura, utapata nafasi ya kushinda zawadi.',
      win_morevote: 'Hongera! Umepata kura {0} zaidi!',
      win_again: 'Hongera! Umepata nafasi moja zaidi!',
      win_normal: 'Hongera! Umepata {0}! Zawadi zitatolewa kwenye siku ya pili ya kazi katika Me-> Kuponi zangu.',
      sorry: 'Asante kwa ushiriki wako.',
      getott: 'LIPIA VIP',
      getdvb: 'UNGANISHA DIKODA&APP',
      sign: 'SAJILI',
      toinvite: 'ALIKA RAFIKI',
      title1: 'MPIGIE KURA MSHIRIKI UNAYEMUUNGA MKONO',
      title2: 'KUPUTA KURA ZAIDI?',
      title3: 'MCHUANO',
      title4: 'MAONYESHO YA ZAMANI'
    },
    bssresult: {
      rule_btn: 'SHERIA',
      share_btn: 'SHIRIKI',
      rule_title: '<p style="color:#55A081;font-weight:bold;">Sheria za kupiga kura</p>',
      rule_text:
        '\n1. Kutoka  tarehe 9 Nov hadi 22 Dec, una kura 5 kila siku baada ya kuingia. Kura zitakuwa zinajumlishwa na kuwa halali hadi mwisho wa shughuli.\n\n2. Unaweza kumpigia kura mshiriki yeyote unayempenda!\n\n3. Wapatie link marafiki zako na waombe wapakue App ya StarTimes ON ili kupata kura zaidi! Utapata kura 5 zaidi kwa kila mtumiaji mpya. Unavyozidi kuleta watumiaji wapya, ndivyo unavyopata kura zaidi! Na pia ukiunganisha Dikoda yako na App, au ukiwa VIP wa App, utapata kura 20 zaidi!\n\n4. Kila wakati unapopiga kura, utapata nafasi moja ya kupata StarTimes Dikoda, Dish, au Max VIP ya Mwezi ya StarTimes ON na Kuponi.\n\n5. Zawadi zitakuwa zinatolewa siku ya pili ya kazi katika Me-> Kuponi zangu.\n\n6. Wagombea 10 wa juu walio na kura nyingi wataweza kuingia kwenye mahojiano ya mwisho, na mwishowe wagombea 5-10 watachaguliwa na mwalimu kushiriki katika 2024BSS S15.',
      share_title: 'Wewe ndiye nyota wa Bongo unayefuata',
      share_text:
        'Chaguo ni lako! Chagua mgombea unayempenda na umsaidie kushiriki kwenye hatua ya utafutaji wa washiriki wa Bongo Star Search 2024.',
      ok: 'SAWA',
      highlights: 'MAONYESHO ZAMANI'
    },
    bsspopular: {
      rule_btn: 'SHERIA',
      share_btn: 'SHIRIKI',
      rule_title: '<p style="color:#55A081;font-weight:bold;">Sheria za kupiga kura</p>',
      rule_text:
        '<p>1.  Wakati wa hafla, una kura 5 kila siku baada ya kuingia. Kura zitakuwa zinajumlishwa na kuwa halali hadi mwisho wa shughuli.</p><p>2. Unaweza kumpigia kura mshiriki yeyote unayempenda!</p><p>3. Wapatie link marafiki zako na wapakue App ya StarTimes ON ili kupata kura zaidi! Utapata kura 5 zaidi kwa kila mtumiaji mpya. Unavyozidi kuleta watumiaji wapya, ndivyo unavyopata kura zaidi! Na pia ukiunganisha Dikoda yako na App, au ukiwa VIP wa App, utapata kura 20 zaidi!</p><p>4. Kila wakati unapopiga kura, utajiongezea nafasi ya kupata zawadi.</p><p>5. Kila mtumiaji anaweza kupata hadi kura 50 kwa siku kwa kushiriki kiungo kwa watumiaji wapya, na idadi ya kura zilizopatikana wakati wa tukio haitazidi 1,000.</p><p>6.Zawadi zitatolewa siku ya pili,bonyeza "Me"->" Kuponi zangu" utaona zawadi zako.</p>',
      share_title: 'StarTimes ON',
      share_text: 'Bongo Star Search Season 15 Dirisha la kupiga kura kwa washiriki pendwa zaidi！！',
      ok: 'SAWA',
      cancel: 'FUTA',
      to_more_vote: 'Jinsi ya kupiga kura zaidi?',
      vote_left: 'Kura zilizobaki:',
      vote: 'KURA',
      tosign: 'JISAJILI',
      tofinish: 'KAMILISHA',
      finished: 'IMEKAMILIKA',
      invite: 'ALIKA',
      invite_text: 'FANIKIWA KUALIKA RAFIKI:',
      info: 'Kila wakati unapopiga kura, utapata nafasi ya kushinda zawadi.',
      lottery_left: 'NAFASI ZILIZOBAKI:',
      tip1: 'Kuponi na zawadi zinaweza kutazamwa hapa, bonyeza “ME” kisha “kuponi yangu”',
      tip2: 'Watumiaji wanaoshinda zawadi,tuwasiliane ili kuzichukua kutoka maduka yaliyoteuliwa',
      vote_title: 'CHAGUA KURA ZAKO',
      close: 'GHAIRI',
      before_start: 'Shughuli haijaanza!',
      after_end: 'Shughuli imeisha!',
      voteleft0: 'Samahani, kura yako iliyobaki ni 0.',
      nomore: 'Kura imeshindikana. Hakuna kura za kutosha zilizobaki.',
      fail1: 'Upigaji umefanikiwa! Shirikisha marafiki kupata kura zaidi.',
      fail2: 'Upigaji umefanikiwa! Umepata nafasi ya kupata zawadi kwa kupitia mchezo wa ukurasa huu.',
      sign_tip: 'Tafadhali jisajili ili uanze mchuano wa bahati.',
      nomore_vote: 'Nenda kupiga kura ili kushinda bahati nzuri ya kuteka. Kila wakati unapopiga kura, utapata nafasi ya kushinda zawadi.',
      win_normal: 'Hongera! Umepata {0}! Zawadi zitatolewa kwenye siku ya pili ya kazi katika Me-> Kuponi zangu.',
      sorry: 'Asante kwa ushiriki wako.',
      has_got: 'umeshinda'
    }
  },
  native: {
    guide: {
      channellistbottom: 'Hakuna Chaneli zaidi',
      channelslist: ' Chaneli',
      channellist: ' Chaneli',
      searchbox: 'Jina la chaneli au nambari',
      searchresults: ' matokeo ya utafutaji yamepatikana kwa ',
      search1result: '1 matokeo ya utafutaji yamepatikana kwa ',
      search0result: 'Hakuna matokeo ya utafutaji yaliyopatikana kwa ',
      noepg: 'Hakuna EPG inayopatikana kwa leo',
      tvguide: 'Mwongozo',
      network_error: 'Tatizo la mtandao.'
    },
    exchangecode: {
      code: 'Kanuni:',
      sure: 'Hakika',
      tips: 'Hongera! ! ! Jaza msimbo wa kukomboa ili ukomboe zawadi! ! !',
      no_sign: 'Watumiaji wapya waliosajiliwa pekee ndio wanaweza kushiriki katika shughuli hii. Kwa hivyo jiandikishe sasa! ! !',
      old_sign: 'Watumiaji wapya waliosajiliwa pekee ndio wanaweza kushiriki katika shughuli hii! ! !',
      error_code: 'Nambari hii si sahihi, tafadhali angalia na ujaze upya ! ! !',
      repeat_code: 'Tayari umeshiriki katika shughuli hii na huwezi kushiriki tena! ! !',
      repeat_device: 'Kifaa hiki tayari kimeshiriki katika shughuli na hakiwezi kushiriki tena! ! ! ',
      h5_call: 'Msimbo wa kukomboa unaweza kutumika tu kwenye programu, tafadhali pakua na usakinishe programu! ! !',
      success_tip1: 'Hongera! ! ! Umepata ',
      success_tip2: ', nenda utazame video sasa! ! !',
      server_error: 'Kosa la seva'
    }
  },
  template: {
    dvbActivity: {
      startimes_on_app: 'STARTIMES ON KWENYE APP',
      download: 'PAKUA',
      rule: 'Kanuni',
      rule_text:
        '<p>1. Kadi mahiri inaweza kuunganishwa kwenye akaunti zisizozidi tatu za Startimes akaunti, ambayo itakuruhusu kufurahia maudhui yanayolipiwa bila malipo.</p><p>2. Ingiza nambari yako ya kadi mahiri na tarakimu sita za mwisho za nambari yako ya kadi ili kuthibitisha kuwa umeunganisha kwenye smart card kwa kuweka nambari yako ya simu ya mkononi.</p><p>3. Ikiwa nambari ya simu ya mkononi unayoingiza haijasajiliwa, unaweza kufuata maagizo ili kupakua programu na kukamilisha usajili kabla ya kuunganisha kadi yako.</p><p>4. Iwapo tayari umesajili namba yako ya simu ya mkononi, unaweza kuunganisha kwenye smart card moja kwa moja</p>',
      smart_card: 'Kitambulisho cha Smartcard',
      decoder: 'Kitambulisho cha Kisimbuzi(tarakimu sita za mwisho)',
      err_code12: 'Namba ya kadi batili',
      err_code13: 'Nambari ya kadi mahiri na nambari ya serial hailingani',
      err_code21: 'KUUNGANISHA IMESHINDWA. Kadi imeunganishwa zaidi ya kikomo (kiwango cha juu cha watumiaji watatu kwa kila kadi)',
      next: 'Inayofata',

      limit_tip1: 'Kadi hii inaweza kuunganishwa kwa jumla ya akaunti 3 za watumiaji. Kwa sasa imeunganishwa kwenye akaunti za ',
      limit_tip2: ' na inaweza kuunganishwa na akaunti za ',
      limit_tip3: '.',
      wait_bind: 'Inasubiri kumfunga...',
      phone_number: 'Namba ya simu:',
      err_code1: 'Kadi imefanikiwa kuunganishwa',
      err_code5: 'Namba ya simu isiyo sahihi',
      err_code15: 'Mtumiaji tayari ameunganisha kadi hii',
      bind: 'Amilisha',

      off: 'Sitisha',
      for_order_above: 'Kwa utaratibu hapo juu',
      coupon: 'kuponi',
      recharge: 'Malipo',
      congratultions: 'Hongera!',
      got_right: 'Nimepata Startimes On Sawa!',
      right_title1: 'Mpango wa Familia',
      right_content1: 'Unaweza kuunganisha hadi wanafamilia watatu kwa Kisimbuzi kimoja',
      right_title2: 'Chaneli ya bure mojakwamoja',
      right_content2: 'Tazama chaneli zote bure kupitia kifurushi ulichojiunga',
      right_title3: 'Maudhui ya bure kila unapohitaji',
      right_content3: 'Furahia zote bila kujiunga kwa mara nyingine ukiwa na supa na uhuru',
      benefits: 'Washa manufaa sasa',
      highlights: 'Vidokezo',

      ok: 'SAWA',
      cancel: 'Cancel',
      server_error: 'Kosa la seva',
      before_start: 'Shughuli haijaanza!',
      after_end: 'Shughuli imeisha!'
    },
    vote: {
      share: 'SAMBAZA',
      vote_left: 'KURA ZILIZOSALIA: ',
      vote: 'KURA',
      sign_tip: 'Ingia kupata kura ',
      ott_tip: 'Unganisha kifurushi cha uhusika kupata kura ',
      dvb_tip: 'Unganisha kadi yako kupata kura ',
      pay_tip: 'Kununua bidhaa ',
      pay_dvb_tip: 'Subscribe StarTimes Decoder ',
      comment_tip: 'Imechapisha maoni ',
      pay_mtn_tip: 'Subscribe ${0} MTN CallerTunez ',
      share_tip: 'Sambaza kupata kura ',
      to_finish: 'Kamilisha',
      finished: 'Imekamilika',
      to_buy: 'Kununua',
      to_share: 'Sambaza',
      more_vote: 'PATA KURA ZAIDI',
      how_many_vote: 'Unataka kumpigia kura ngapi mshiriki?',
      ok: 'SAWA',
      cancel: 'Cancel',
      before_start: 'Shughuli haijaanza!',
      after_end: 'Shughuli imeisha!',
      server_error: 'Kosa la seva',
      vote_success: 'Kura imefanikiwa. ',
      vote_error: 'Makosa ya kura. ',
      vote0_get_more: 'Kura zako ni 0, malizia zoezi kuongeza kura zaidi! ',
      copied: 'Web link has been copied',
      no_support_copy: 'Copy is not supported on your browser, please try to make a long press to copy'
    },
    voteLottery: {
      sign_alert: '请登录后抽奖',
      lottery_left: 'LOTTERY LEFT:',
      has_got: 'has got',
      win_tip:
        'Kuponi na zawadi za wanachama zinaweza kutazamwa Tkwangu->Kuponi yangu baada ya tukio kuisha</br>Watumiaji wanaoshinda zawadi za vitu watawasiliana nawe ili kuzichukua kwenye maduka yetu yaliyoteuliwa',
      lottery0_get_more: '没有抽奖机会了，投票获取更多抽奖机会吧！',
      win_text: '恭喜你, 获得了',
      win_vote: 'xxx票!',
      win_thanks: '很抱歉没中奖',
      win_try_again: '恭喜你, 你还有一次机会!',
      my_prize: 'My Prize',
      loading: '加载中...',
      empty_list: '你还没有中奖哦'
    },
    guidebind: {
      share: 'Share',
      ok: 'OK',
      cancel: 'Cancel',
      after_end: 'The event has ended',
      after_end_toast: 'The current event has ended. Please stay tuned to Startimes ON for more amazing discounts!',
      server_error: 'Server error!',
      btn_down: 'Download & Redeem',
      btn_sign: 'Sign In & Redeem',
      link_not_bind: 'Why Not a TV Reward? >',
      btn_not_bind: 'Redeem & Use now',
      link_bind: 'Redeem a mobile VIP >',
      btn_bind: 'Join TV PROMO',
      sign_in_content:
        '<div style="text-align: left;line-height: 20px;">For a better experience in Easter Promo, please remember to <span style="color: #ffc107;font-weight: bold;">SIGN IN</span> with your<br />1. <span style="color: #f44336;font-weight: bold;">Phone Number</span> <br />2. <span style="color: #f44336;font-weight: bold;">Smartcard Number</span> as your <span style="font-weight: bold;">password</span>. <br />Then ALL Unlimited movies&TV shows shall be available and FREE for u ONLY!</div>'
    },
    userfission: {
      share: 'SHARE',
      like: 'LIKE',
      liked: 'LIKED',
      sure: 'SURE',
      join_btn: 'JOIN NOW',
      prize_title: 'Congratultions',
      share_title: 'ACTIVITY',
      like_title: 'ACTIVITY',
      video_title: 'JOIN AND ENJOY',
      step_title: 'HOW CAN I JOIN THIS ACTIVITY',
      ok: 'OK',
      cancel: 'Cancel',
      after_end: 'Sorry, the activity has ended!',
      server_error: 'Server error! Try again later.',
      country_error: 'The activity in the current country has not started yet, please wait a little!',
      sign_tip: 'Login to partiaipate in the activity',
      has_got: 'has got',
      congratultions1: 'Congratultions!!! You have got ',
      congratultions2: 'Your friend ${0} have got ',
      for_free: ' FOR FREE',
      my_bonus_btn: 'MY BONUS DETAIL >',
      my_bonus: 'Bonus details',
      first_share: 'FIRST TIME SHARE THIS PAGE TO YOUR FRIENDS, GET /*${0} IMMEDIATELY*/',
      has_share: 'YOU HAVE GOT /*${0}*/ LIKES FROM YOUR FRIENDS',
      share_excess: 'GET MORE LIKES from YOUR FRIENDS, GET /*MORE VIP*/',
      liked_excess: 'You have helped your friends get ',
      like_excess: 'LIKE FOR your friend, GET MORE VIP',
      like_no_excess: 'Many of your friends have received benefits, hurry up and participate in the activity to get FREE STARTIMES ON ',
      like_success: 'Successful! Thanks for your action.',
      like_limit_tip: 'The opportunity to like has reached the upper limit for today, open the StarTimes ON, participate in the ACTIVITY'
    },
    unitmember: {
      error_text: 'Please enter a valid phone number.',
      placeholder: 'Namba ya simu',
      ok: 'SAWA',
      server_error: 'Kosa la seva',
      before_start: 'Shughuli haijaanza!',
      after_end: 'Shughuli imeisha!'
    }
  },
  clause: {
    comment: {
      title: '《Miongozo ya Maoni》',
      desc1:
        'Unapotumia StarTimes ON, utakuwa kwenye jumuiya ya marafiki walio na maudhui tajiri. Miongozo ifuatayo husaidia kuhakikisha kuwa kila mtu anapata matumizi ya kufurahisha na kufurahisha ya StarTimes ON.',
      desc1:
        'Unapotumia StarTimes ON, utakuwa kwenye jumuiya ya marafiki walio na maudhui tajiri. Miongozo ifuatayo husaidia kuhakikisha kuwa kila mtu anapata matumizi ya kufurahisha na kufurahisha ya StarTimes ON.',
      desc2: 'Ikiwa unafikiri kuwa umeona maudhui yanayokiuka miongozo hii, bofya "aikoni ya bendera".',
      subTitle1: '- Spam na Udanganyifu',
      content1:
        'Uaminifu ndio msingi ambao StarTimes ON inajengwa juu yake, na StarTimes ON haivumilii uchapishaji wa maudhui ambayo yanalenga kuhadaa, kupotosha au kuwalaghai watumiaji wengine au barua taka.',
      content1:
        'Uaminifu ndio msingi ambao StarTimes ON inajengwa juu yake, na StarTimes ON haivumilii uchapishaji wa maudhui ambayo yanalenga kuhadaa, kupotosha au kuwalaghai watumiaji wengine au barua taka.',
      subTitle2: '- Maudhui Nyeti',
      content2: 'Tunataka kuwalinda watumiaji wetu, haswa watoto. Kwa hivyo, tafadhali epuka kutuma maoni ambayo yanahatarisha usalama wa watoto.',
      subTitle3: '- Maudhui ya Vurugu au Hatari',
      content3:
        'StarTimes ON hairuhusu uchapishaji wa matamshi ya chuki, tabia ya unyanyasaji, maudhui yaliyoandikwa kwa jeuri, mashambulizi mabaya na maudhui ambayo yanaendeleza tabia hatari au hatari.',
      content3:
        'StarTimes ON hairuhusu uchapishaji wa matamshi ya chuki, tabia ya unyanyasaji, maudhui yaliyoandikwa kwa jeuri, mashambulizi mabaya na maudhui ambayo yanaendeleza tabia hatari au hatari.',
      subTitle4: '- Vipengee Vinavyodhibitiwa',
      content4: 'Tafadhali usichapishe bidhaa zinazodhibitiwa zinazouzwa kwenye StarTimes ON ambazo zinakiuka sera za ndani.',
      subTitle5: '- Taarifa za Uongo',
      content5:
        'StarTimes ON hairuhusu uchapishaji wa aina fulani za maudhui yanayopotosha au maudhui ya udanganyifu ambayo yanaweza kuleta hatari kubwa ya madhara makubwa. Hii ni pamoja na aina mahususi za maelezo ya uwongo ambayo yanaweza kusababisha madhara katika ulimwengu halisi (kama vile utangazaji wa tiba hatari au tiba), aina mahususi za maudhui ambayo yanabadilishwa kiteknolojia, au maudhui ambayo yanaingilia mchakato wa kidemokrasia.',
      desc3:
        'Tafadhali zingatia madhubuti sheria hizi. Ikiwa tabia yako ndani au nje ya Jukwaa itadhuru watumiaji wetu, jumuiya, wafanyakazi au mfumo ikolojia, tunaweza kuchukua hatua kulingana na mseto wa mambo, ikiwa ni pamoja na, lakini sio tu, ubaya wa tabia na kama ina madhara au la. . Katika hali ya tabia kama hiyo, tunaweza kusimamisha haki za kuzungumza za akaunti yako kwa tabia mbaya sana, au kuzima akaunti yako kwa tabia kali zaidi.'
    },
    screen: {
      title1: 'Screen casting usage method',
      p1:
        'Hatua ya 1: Ongeza programu ya StarTimes kwenye kifaa cha mradi na kuthibitisha kuwa kifaa hicho kinaunganishwa na Wi Fi kama simu<br/>Hatua ya 2: Bofya " TV Screen" kwenye kona ya juu kulia na uchague kifaa cha kukadiria skrini ambacho kimepakua Programu ya StarTimes ON ili kukamilisha makadirio ya skrini.',
      title2: 'Ikiwa kifaa cha makadirio ya skrini hakiwezi kupatikana',
      p2:
        'ukaguzi ufuatao unaweza kufanywa:<br/>1. Kifaa cha kutumia skrini kimewekewa Programu ya StarTimes. Ikiwa hakina, unaweza kufungua TV/Box App Store na kupakua Programu ya "StarTimes ON App" bila malipo kabla ya kuunganisha na skrini ili kuitazama.<br/>2. Kifaa cha kuakisi skrini kimewashwa na kuunganishwa kwa Wi Fi sawa na simu.<br/>3. Kifaa kimeungana na uakisi wa skrini. Ikiwa haiwezekani kuthibitisha, inashauriwa kushauriana na mtengenezaji wa vifaa.<br/>4. Kutengwa kwa AP na kazi za mode ya mgeni wa router zimezimwa, na mtandao wa amplifier ya ishara haujaunganishwa. Ikiwa bado haijatumwa kwa ufanisi, unaweza kuanzisha upya vifaa vya mtandao kama vile routers.<br/>5. Watumiaji wa iOS 14 au iPadOS 14, tafadhali thibitisha kuwa ruhusa za mtandao wa ndani zimewezeshwa katika "Mipangilio - Faragha - Mtandao wa Ndani - StarTimes".<br/>6. Baada ya kuthibitisha kuwa hakuna matatizo yaliyotajwa hapo juu, tafadhali anzisha upya programu ya StarTimes na ujaribu kuakisi skrini tena.',
      title3: 'Jinsi ya kutatua kutofaulu kwa utumiaji wa skrini?',
      p3:
        'Unaweza kujaribu suluhisho mbili zifuatazo:<br/>1. Angalia ikiwa TV/kisanduku kinaweza kufikia mtandao kwa njia ya kawaida.<br/>2. Je, kifaa cha kutuma skrini kimepakuliwa Programu ya StarTimes ON? Ikiwa sivyo, unaweza kufungua programu ya TV/Box na kupakua Programu ya "StarTimes ON" bila malipo kabla ya kutuma kwenye skrini ili kutazamwa.',
      title4: 'Ilikwama wakati wa kuunga na skrini',
      p4:
        '1. Mtandao wa sasa au kifaa cha kuakisi skrini huenda hakiruhusu video za ubora wa hali ya juu. Inapendekezwa kupunguza ubora wa video ili kuhakikisha uchezaji mzuri wa video inayoakisi skrini.<br/>2. Je, kifaa cha kuakisi skrini kinaweza kufikia mtandao kwa kawaida.<br/>3. Iwapo kasi ya mtandao ya kifaa cha kukadiria skrini ni thabiti.<br/>4. Je, kuna vifaa vingine katika mtandao huo ambavyo vinachukua kiasi kikubwa cha bandwidth.',
      title5: 'Kuna matatizo kama vile kuruka vipindi au kutoweza kuendelea kwa matangazo wakati wa utumiaji wa skrini',
      p5: 'Tunapendekeza kuwasha upya programu ya StarTimes ON ili kuanzisha utumiaji skrini tena huku ukidumisha muunganisho wa kawaida wa mtandao.',
      title6: 'Kwa nini baadhi ya video hazionyeshi kwenye uakisi wa skrini?',
      p6:
        'Baadhi ya maudhui yameombwa na mwenye hakimiliki na hayawezi kuonekana kwenye utumiaji wa skrini. Unaweza kuchagua kucheza aina hii ya maudhui moja kwa moja kwenye simu yako ya mkononi au kuitazama moja kwa moja kwenye TV yako.',
      title7: 'Jinsi ya kuunga skrini kwenye kompyuta kwa ajili ya kutazama?',
      p7: 'Kwa sasa haitumii uakisi wa skrini kwenye upande wa kompyuta.',
      TVtitle: 'Screen casting usage method',
      step1:
        '<span style="font-weight: bold;">Hatua ya 1:</span> Ongeza kifaa cha kurusha skrini na uweke programu ya StarTimes ON, ukihakikisha kuwa kifaa hicho kimeunganishwa na mtandao wa Wi-Fi sawa na simu yako.',
      step2:
        '<span style="font-weight: bold;">Hatua ya 2:</span> Bofya " TV Screen"  kwenye kona ya juu kulia na uchague kifaa cha kukadiria skrini ambacho kimepakua Programu ya StarTimes ON  ili kukamilisha makadirio ya skrini.'
    }
  }
}
